import { render, staticRenderFns } from "./ImagePage.vue?vue&type=template&id=6d2b0053&scoped=true&"
import script from "./ImagePage.vue?vue&type=script&lang=js&"
export * from "./ImagePage.vue?vue&type=script&lang=js&"
import style0 from "./ImagePage.vue?vue&type=style&index=0&id=6d2b0053&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2b0053",
  null
  
)

export default component.exports